// import Popup from '../lib/popup';
// import { fetchSection } from '../lib/utils';

class KlaviyoBis extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const trigger = this.querySelector('[data-open-bis]');
    if (!trigger) return;
    trigger.addEventListener('click', this.onOpenBisClick.bind(this));
  }

  async onOpenBisClick(e) {
    e.preventDefault();

    this.popup = new Popup();

    const html = await fetchSection(
      `/products/${this.dataset.productHandle}?section_id=product-notifyme`
    ).then((section) => section.innerHTML);

    this.popup.insertContent(html);

    this.popup.el.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  onFormSubmit(e) {
    if (!e.target.matches('[data-shopify-cart-notify-form]')) return;

    e.preventDefault();

    const emailInput = e.target.querySelector('input[type="email"]');
    if (emailInput && !emailInput.value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      emailInput.setCustomValidity('Please enter a valid email address.');
      emailInput.reportValidity();
      emailInput.setCustomValidity('');
      return;
    }

    const btn = e.target.querySelector('button[type="submit"]');
    this._originalBtnHTML = btn.innerHTML;

    btn.classList.add('loading');
    btn.innerHTML = `
      <svg class="loading-spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <g fill="currentColor"><g><path d="M24 47a23 23 0 1 1 23-23 23.025 23.025 0 0 1-23 23zm0-42a19 19 0 1 0 19 19A19.021 19.021 0 0 0 24 5z" opacity=".4"></path><path d="M47 24h-4A19.021 19.021 0 0 0 24 5V1a23.025 23.025 0 0 1 23 23z"></path></g></g>
      </svg>
    `;

    this.createNotification(e.target);
  }

  createNotification(form) {
    const formData = new FormData(form);
    formData.get('email');
    formData.get('variant_id');
    formData.get('product_id');

    const url =
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.dataset.klaviyoKey}`;

    let formattedData = {
      email: formData.get('email'),
      variant: formData.get('variant_id'),
      platform: 'shopify',
      subscribe_for_newsletter: false
    };

    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": formData.get('email'),
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": `$shopify:::$default:::${formData.get('variant_id')}`
            }
          }
        }
      }
    }

    const options = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "revision":"2024-06-15"
      },
      body: JSON.stringify(payload)
    };

    fetch(url, options).then((res) => {
      if (res.status !== 200 && res.status !== 202) {
        throw res;
      }

      this.popup.replaceContent(
        `<p class="p-6">You're in! We'll let you know when it's back.</p>`
      );
    }).catch(() => {
      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.classList.remove('loading');
        btn.innerHTML = this._originalBtnHTML || 'Notify me';
      }
      this.popup.replaceContent(
        `<p class="p-6">Something went wrong. Please try again.</p>`
      );
    });
  }
}

if (!customElements.get('klaviyo-bis', KlaviyoBis)) {
  customElements.define('klaviyo-bis', KlaviyoBis);
}
